import { MutationTree } from 'vuex';
import { State } from './state';
import { Artikel } from '@/modules/ewwms/models/Lager/ArtikelModels';

export enum MutationTypes {
  SetArtikel = 'SETARTIKEL',
}

export type Mutations = {
  [MutationTypes.SetArtikel](state: State, data: Array<Artikel>): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SetArtikel](state, data) {
    state.artikel = data;
    sessionStorage.setItem('artikel', JSON.stringify(state.artikel));
  },
};
